<template>
    <v-card flat color="transparent">
        <v-layout align-center justify-center>
            <v-flex lg4 md4 sm4 xs10>
                <v-card-title class="justify-center">
                    <p class="headline">
                        Create an Account
                    </p>
                </v-card-title>
                <v-card-text>
                    <v-form @submit.prevent="submit">
                        <v-layout row warp>
                            <v-flex lg5>
                                <v-text-field
                                        outlined
                                        ref="name"
                                        v-model.trim="$v.user.attributes.name.$model"
                                        label="Name"
                                        :error-messages="nameError"
                                        error-count=2
                                        required>
                                </v-text-field>
                            </v-flex>
                            <v-spacer></v-spacer>
                            <v-flex lg5>
                                <v-text-field
                                        outlined
                                        ref="lastName"
                                        v-model.trim="$v.user.attributes.family_name.$model"
                                        label="Last Name"
                                        :error-messages="lastNameError"
                                        error-count=2
                                        required>
                                </v-text-field>
                            </v-flex>
                            <v-flex lg5>
                                <datePicker  :errorFn = "dobError"
                                             labelProp="DOB"
                                             @dateValue="$v.user.attributes.birthdate.$model = $event"
                                ></datePicker>
                            </v-flex>
                            <v-spacer></v-spacer>
                            <v-flex lg5>
                                <v-text-field
                                        outlined
                                        ref="phone"
                                        v-model.trim="$v.phone.$model"
                                        label="Phone number"
                                        :error-messages="phoneError"
                                        v-mask="'###-###-####'"
                                        hint="ie. 305-999-9999"
                                        required>
                                </v-text-field>
                            </v-flex>
                            <v-flex lg5>
                                <v-text-field
                                        outlined
                                        ref="address"
                                        v-model.trim="$v.address.addrs.$model"
                                        label="Address"
                                        :error-messages="addressError"
                                        error-count=2
                                        required>
                                </v-text-field>
                            </v-flex>
                            <v-spacer></v-spacer>
                            <v-flex lg5>
                                <v-text-field
                                        outlined
                                        ref="address"
                                        v-model.trim="address.apt"
                                        label="Apt #"
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex lg3>
                                <v-text-field
                                        outlined
                                        ref="address"
                                        v-model.trim="$v.address.city.$model"
                                        label="City"
                                        :error-messages="addressCityError"
                                        error-count=2
                                        required>
                                </v-text-field>
                            </v-flex>
                            <v-spacer></v-spacer>
                            <v-flex lg3>
                                <usStatesSelect :state="address.state"
                                                :error-fn="addressStateError"
                                                :required="true"
                                                @state-selected="address.state = $event">

                                </usStatesSelect>
                            </v-flex>
                            <v-spacer></v-spacer>
                            <v-flex>
                                <v-text-field
                                        outlined
                                        ref="address"
                                        v-model.trim="$v.address.zip_code.$model"
                                        label="Zip Code"
                                        :error-messages="addressZipError"
                                        error-count=2
                                        v-mask="'#####'"
                                        required>
                                </v-text-field>
                            </v-flex>
                            <v-flex lg12>
                                <v-text-field
                                        outlined
                                        ref="email"
                                        v-model.trim="$v.user.attributes.email.$model"
                                        type="email"
                                        label="Email address"
                                        hint="ie. admin@nstartsoft.com"
                                        :error-messages="emailError"
                                        required>
                                </v-text-field>
                            </v-flex>
                            <v-flex lg12>
                                <v-text-field
                                        outlined
                                        ref="username"
                                        v-model.trim="$v.user.username.$model"
                                        label="Username"
                                        :error-messages="usernameError"
                                        error-count=2
                                        hint="ie. adminNstartSoft"
                                        required>
                                </v-text-field>
                            </v-flex>
                            <v-flex lg12>
                                <v-text-field
                                        outlined
                                        ref="password"
                                        v-model.trim="$v.user.password.$model"
                                        type="password"
                                        label="Password"
                                        :error-messages="passwordError"
                                        hint="Must contain lower and upper case character, one number and one symbol, ie. $12&*!)JHSert"
                                        required>
                                </v-text-field>
                            </v-flex>
                            <v-flex lg12>
                                <v-text-field
                                        outlined
                                        ref="password"
                                        v-model.trim="$v.checkPassword.$model"
                                        type="password"
                                        label="Retype Password"
                                        :error-messages="passwordCheckError"
                                        required>
                                </v-text-field>

                            </v-flex>
                        </v-layout>

                        <v-alert
                                v-model="alert.show"
                                dismissible
                                outlined
                                :type= "alert.type">
                            {{alert.msg}}
                        </v-alert>
                        <div class="ma-3"></div>

                        <v-layout row wrap align-center justify-center>
                            <v-flex>
                                <v-btn  color="primary"
                                        large
                                        block
                                        v-if="showSubmit"
                                        type="submit">
                                    SEND
                                </v-btn>
                            </v-flex>
                            <v-spacer></v-spacer>
                            <v-flex>
                                <v-btn text
                                       block
                                       large
                                       @click.prevent="close">
                                    {{showSubmit ? 'Cancel' : 'Log In'}}
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
    import {Auth} from 'aws-amplify';
    import { required, minLength, email} from 'vuelidate/lib/validators'
    import { AmplifyEventBus } from 'aws-amplify-vue';
    const uuidv4 = require('uuid/v4');
    import {ACCT_TYPES} from '@/shared/enums/UserType';
    import {TOKEN} from '@/shared/enums/TokenSeparator';
    const datePicker = () => import('@/components/common/DatePicker');
    const usStatesSelect = ()=> import( '@/components/common/UsStatesSelect');

    export default {
        name: "SignUp",
        components:{
            datePicker, usStatesSelect
        },
        props: ['isCognitoReg'],
        data(){
            return{
                user:{
                    username:'',
                    password:'',
                    attributes:{
                        name:'',
                        family_name:'',
                        birthdate: '',
                        address:'',
                        email:'',
                        phone_number:''
                    }
                },
                checkPassword: null,
                phone:'',
                alert: {
                    show: false,
                    type:'success',
                    msg: 'Success'
                },
                showSubmit: true,
                address:{
                    addrs: '',
                    apt: '',
                    city: '',
                    state: '',
                    zip_code:''
                }
            }
        },
        validations: {
            user:{
                username: {
                    required: required,
                    minLength: minLength(6)
                },
                password: {
                    required: required,
                    minLength: minLength(8)
                },
                attributes: {
                    name:{
                        required
                    },
                    family_name:{
                        required
                    },
                    birthdate:{
                        required
                    },
                    email: {
                        required,
                        email: email
                    }
                }
            },
            phone: {
                required
            },
            checkPassword: {
                sameAsPassword: function () {
                    return this.checkPassword === this.user.password;
                }
            },
            address: {
                addrs: {
                    required
                },
                city: {
                    required
                },
                state: {
                    required
                },
                zip_code: {
                    required
                }
            }
        },
        computed:{
            isCognitoRegistration(){
              return this.isCognitoReg;
            },
            usernameError(){
                const errors = []
                if (!this.$v.user.$dirty) {
                    return errors
                }

                !this.$v.user.username.minLength && errors.push('Username must be at least '+
                    this.$v.user.username.$params.minLength.min +' characters long')
                !this.$v.user.username.required && errors.push('Username is required.')
                return errors
            },
            passwordError(){
                const errors = []
                if (!this.$v.user.$dirty) {
                    return errors
                }

                !this.$v.user.password.minLength && errors.push('Password must be at least '+
                    this.$v.user.password.$params.minLength.min +' characters long')
                !this.$v.user.password.required && errors.push('Password is required.')
                return errors
            },
            passwordCheckError(){
                const errors = []
                if (!this.$v.user.$dirty) {
                    return errors
                }

                !this.$v.checkPassword.sameAsPassword && errors.push('Passwords need to match.')
                return errors
            },
            nameError(){
                const errors = []
                if (!this.$v.user.$dirty) {
                    return errors
                }

                !this.$v.user.attributes.name.required && errors.push('Name is required.')
                return errors
            },
            lastNameError(){
                const errors = []
                if (!this.$v.user.$dirty) {
                    return errors
                }

                !this.$v.user.attributes.family_name.required && errors.push('Last name is required.')
                return errors
            },
            dobError(){
                const errors = []
                if (!this.$v.user.$dirty) {
                    return errors
                }

                !this.$v.user.attributes.birthdate.required && errors.push('DOB is required.')
                return errors
            },
            addressError(){
                const errors = []
                if (!this.$v.address.$dirty) {
                    return errors
                }

                !this.$v.address.addrs.required && errors.push('Address is required.')
                return errors
            },
            addressCityError(){
                const errors = []
                if (!this.$v.address.$dirty) {
                    return errors
                }

                !this.$v.address.city.required && errors.push('City is required.')
                return errors
            },
            addressStateError(){
                const errors = []
                if (!this.$v.address.$dirty) {
                    return errors
                }

                !this.$v.address.state.required && errors.push('State is required.')
                return errors
            },
            addressZipError(){
                const errors = []
                if (!this.$v.address.$dirty) {
                    return errors
                }

                !this.$v.address.zip_code.required && errors.push('Zip Code is required.')
                return errors
            },
            emailError(){
                const errors = []
                if (!this.$v.user.$dirty) {
                    return errors
                }

                !this.$v.user.attributes.email.email && errors.push('A valid email address is required')
                !this.$v.user.attributes.email.required && errors.push('Email address is required.')
                return errors
            },
            phoneError(){
                const errors = []
                if (!this.$v.phone.$dirty) {
                    return errors
                }
                !this.$v.phone.required && errors.push('Phone number is required.')
                return errors
            }
        },
        methods: {
            async singUp(){
                if(this.isCognitoRegistration){
                    await this.cognitoReg();
                    return;
                }

                await this.apiReg();
            },
            async cognitoReg(){
                try {
                    await Auth.signUp(this.user);
                    this.setAlert('success', 'An email have been sent to this email address: '+
                        this.user.attributes.email+'. Please check your mail box for verification of the account')
                    this.$emit('submit', true)
                    this.showSubmit = false
                }
                catch (e) {
                    this.$emit('submit', false)
                    this.setAlert('error', e.message)
                }
            },
            async apiReg() {
                this.$store.commit('setCognitoUser', this.user);
            },
            submit(){
                this.$v.user.$touch();
                this.$v.address.$touch();
                this.$v.phone.$touch();

                if(this.$v.user.$anyError){
                    return;
                }

                this.user.username = this.user.username.toLowerCase()

                this.phone = this.phone.split('-').join('');
                this.user.attributes.phone_number = '+1'+this.phone;

                this.user.attributes.address = this.address.addrs + TOKEN +
                    this.address.apt + TOKEN +
                    this.address.city + TOKEN +
                    this.address.state + TOKEN +
                    this.address.zip_code;
                //check if the user is authenticated? get orgID and assign to this new user and set acctType to secondary
                let cognitoUser = this.$store.getters.getUser;

                if(cognitoUser  === null) {
                    this.user.attributes['custom:orgID'] = uuidv4();
                    this.user.attributes['custom:acctType'] = ACCT_TYPES.ORGANIZATION;
                }
                else {
                    this.user.attributes['custom:acctType'] = ACCT_TYPES.EMPLOYEE;
                }
                this.singUp();
                this.$emit('close', true);
            },
            close(){
                this.$emit('close', false);
                AmplifyEventBus.$emit('authState', 'signedIn');
            },
            setAlert(type, msg){
                this.alert.show = true;
                this.alert.type = type;
                this.alert.msg = msg;
            }
        }
    }
</script>

<style scoped>

</style>